export default __webpack_public_path__ + "static/media/Assets.2d8acb77.png";